import { View } from "@/enums";
import InfraUrl from "@/models/InfraUrl";
import { Store } from "./store";

interface LoginData extends Record<string, unknown> {
  username: string;
  customerId: string;
  password: string;
  view: View;
  successMessage: string;
  errorMessage: string;
  isLoading: boolean;
  clientIds: string[];
  infraUrls: InfraUrl[];
  redirectUrl: string;
}

class LoginDataStore extends Store<LoginData> {
  protected data(): LoginData {
    return {
      username: "",
      customerId: "",
      password: "",
      view: View.USERINFO,
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      clientIds: [],
      infraUrls: [],
      redirectUrl: "",
    };
  }

  setUsername(value: string) {
    this.state.username = value;
  }

  setCustomerId(value: string) {
    this.state.customerId = value;
  }

  setPassword(value: string) {
    this.state.password = value;
  }

  setView(value: View) {
    this.state.view = value;
  }

  setSuccessMessage(value: string) {
    this.state.successMessage = value;
  }

  setErrorMessage(value: string) {
    this.state.errorMessage = value;
  }

  setIsLoading(value: boolean) {
    this.state.isLoading = value;
  }

  setClientIds(value: string[]) {
    this.state.clientIds = value;
  }

  setInfraUrls(value: InfraUrl[]) {
    this.state.infraUrls = value;
  }

  setRedirectUrl(value: string) {
    this.state.redirectUrl = value;
  }
}

export const store: LoginDataStore = new LoginDataStore();
